import statisticData from "../localData/statisticData.json";

const statistics = (state = statisticData, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default statistics;
